<template>
  
  <modal
    title="Companies"
    @close="$emit('close')"
  >
    <template #content>
        <loadArea v-if="data==null"></loadArea>
          <dataTable
            :name="'getCompanies'"
            v-if="data != null"
            ref="agGrid"
            :columnDefs="columnDefs"
            :data="data"
            @cellClicked="
              $emit('selectCompany',$event.data);
            "
          ></dataTable>
    </template>
  </modal>
</template>

<script>
    export default {
        name:"getCompanies",
        props:["model"],
        data(){
            return {
                data:null,
                columnDefs: [
                    {
                    headerName: "RecId",
                    field: "RecId",
                    enableRowGroup: true,
                    floatingFilter: true,
                    filter: "agTextColumnFilter",
                    flex: 1,
                    minWidth: 140,
                    },
                    {
                    headerName: "CompanyCode",
                    field: "CompanyCode",
                    enableRowGroup: true,
                    floatingFilter: true,
                    filter: "agTextColumnFilter",
                    flex: 1,
                    minWidth: 140,
                    },
                    {
                    headerName: "Name",
                    field: "Name",
                    enableRowGroup: true,
                    floatingFilter: true,
                    filter: "agTextColumnFilter",
                    flex: 1,
                    minWidth: 140,
                    }
                ],
            }
        },
        created(){
            this.$appAxiosAdmin
                .post(`PMS/Sedna/Companies`, {
                SoftwareId: this.model.SoftwareId,
                CustomerId: this.model.CustomerId,
                P1: this.model.P1,
                P2: this.model.P2,
                P3: this.model.P3,
                P4: this.model.P4,
                P5: this.model.P5,
                P6: this.model.P6,
                P7: this.model.P7,
                P8: this.model.P8,
                P9: this.model.P9,
                P10: this.model.P10,
                P11: this.model.P11,
                P12: this.model.P12,
                P13: this.model.P13,
                P14: this.model.P14,
                // this.model
                })
                .then(response => {
                    this.data=response.data;
                })
                .catch((err) => {
                    this.$isError(err);
                });
        }
    }
</script>

<style>

</style>